import { createReduxSlice } from '@app/store/redux_slice'

const catalogSlice = createReduxSlice<{ list: { id: string; name: string; entries: { name: string; url: string }[] }[] }>(
  'catalog-41b3b974-18d5-42dc-9dc7-2f405ec46c4a'
)

export const setCatalog = catalogSlice.set

export const catalogSelector = catalogSlice.selector
